import { render, staticRenderFns } from "./SamclickButton.vue?vue&type=template&id=55952368&functional=true&"
import script from "./SamclickButton.vue?vue&type=script&lang=ts&"
export * from "./SamclickButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports